document.addEventListener('DOMContentLoaded', function () {
  // Funktion, um das Energielabel anhand des Metafelds hinzuzufügen
  function addEnergyLabels() {
    // Suche nach allen Produkten in der Übersicht
    const products = document.querySelectorAll('.product-item'); // Passe den Selektor an dein Theme an
    
    products.forEach(product => {
      // Prüfe, ob das Metafeld existiert
      const metaField = product.dataset.staylimeEprelRegistrationNumber; // Metafeld sollte im HTML eingebunden sein
      if (metaField) {
        // Überprüfen, ob das Label bereits existiert, um Duplikate zu vermeiden
        if (!product.querySelector('.energy-label')) {
          // Label-Div erstellen
          const labelDiv = document.createElement('div');
          labelDiv.className = 'energy-label';
          labelDiv.innerText = `Energielabel: ${metaField}`; // Optional: Stil anpassen

          // Label an der gewünschten Stelle einfügen
          product.appendChild(labelDiv);
        }
      }
    });
  }

  // Beobachter für das Nachladen von Produkten
  const collectionContainer = document.querySelector('.collection-grid'); // Passe den Selektor an
  if (collectionContainer) {
    const observer = new MutationObserver(() => {
      addEnergyLabels();
    });

    observer.observe(collectionContainer, { childList: true, subtree: true });
  }

  // Initiales Hinzufügen der Labels
  addEnergyLabels();
});
